import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { purchase } from "@api/courses/enrollments/purchase/path";
import { request } from "@api/courses/enrollments/request/path";

const pathBase = `/courses/:courseId/enrollments/`;
const pathById = `${pathBase}:enrollmentId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const enrollments = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  patch: apiPathFunc(pathById),
  purchase,
  request,
} as const;
